// NOTE: This file must remain a JS file because
// it's used in `vite.config.js`

export const VERSION = '1.4.2'
export const RELEASE_TIME = 1715579420527
